import { createContext, useContext, useEffect, useState } from "react";
import authHeader from "../../Auth/authHeader";
import { getCompanyVatDeclarant } from "../GetCompanyData";

const VatDeclarantContext = createContext(null);

// const headers = authHeader();

export const VatDeclarantProvider = ({ children }) => {
    const [isVatDeclarant, setIsVatDeclarant] = useState(null);

    // useEffect(() => {
    //     const fetchVatStatus = async () => {
    //         const result = await getCompanyVatDeclarant(headers);
    //         setIsVatDeclarant(result);
    //         // alert(result);
    //     };
    //     fetchVatStatus();
    // }, [headers]);

    useEffect(() => {
        const fetchVatStatus = async () => {
            const headers = authHeader();
            if (!headers || !headers.Authorization) {
                return; // Mos e thirr API-n nëse nuk ka token
            }

            const result = await getCompanyVatDeclarant(headers);
            setIsVatDeclarant(result);
        };

        fetchVatStatus();
    }, []); // mos vendos headers si dependency

    return (
        <VatDeclarantContext.Provider value={isVatDeclarant}>
            {children}
        </VatDeclarantContext.Provider>
    );
};

export const useVatDeclarant = () => useContext(VatDeclarantContext);
